import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a baby crib (~0.7 x 1.3, length along Z): four oak posts,
// slatted long sides, solid end panels, a white mattress slab.
const OAK = "#c8975a";
const MATTRESS = "#f2efe8";

export const crib = defineModel({
  id: "crib",
  batchId: "modern",
  name: "Crib",
  tags: ["modern", "interior", "furniture", "bedroom", "bed", "nursery"],
  summary: "An oak baby crib with slatted sides and a white mattress.",
  tiles: { w: 1, h: 2 },
  footprint: 1.0,
  parts(): Part[] {
    const slats: Part[] = [];
    for (const x of [-0.325, 0.325]) {
      for (const z of [-0.42, -0.21, 0, 0.21, 0.42]) {
        slats.push({
          geometry: new THREE.BoxGeometry(0.03, 0.42, 0.03),
          color: OAK,
          position: [x, 0.6, z],
        });
      }
    }
    return [
      // corner posts
      { geometry: new THREE.BoxGeometry(0.05, 0.9, 0.05), color: OAK, position: [-0.325, 0.45, -0.625] },
      { geometry: new THREE.BoxGeometry(0.05, 0.9, 0.05), color: OAK, position: [0.325, 0.45, -0.625] },
      { geometry: new THREE.BoxGeometry(0.05, 0.9, 0.05), color: OAK, position: [-0.325, 0.45, 0.625] },
      { geometry: new THREE.BoxGeometry(0.05, 0.9, 0.05), color: OAK, position: [0.325, 0.45, 0.625] },
      // base frame + mattress
      { geometry: new THREE.BoxGeometry(0.7, 0.08, 1.3), color: OAK, position: [0, 0.3, 0] },
      { geometry: new THREE.BoxGeometry(0.6, 0.1, 1.2), color: MATTRESS, position: [0, 0.39, 0] },
      // top rails along the long sides
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 1.25), color: OAK, position: [-0.325, 0.84, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 1.25), color: OAK, position: [0.325, 0.84, 0] },
      // solid end panels
      { geometry: new THREE.BoxGeometry(0.6, 0.52, 0.04), color: OAK, position: [0, 0.6, -0.625] },
      { geometry: new THREE.BoxGeometry(0.6, 0.52, 0.04), color: OAK, position: [0, 0.6, 0.625] },
      // vertical slats on the long sides
      ...slats,
    ];
  },
  animations: [],
});
